var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.2727C11.4213 10.2727 10.8664 10.5026 10.4572 10.9118C10.0481 11.3209 9.81818 11.8759 9.81818 12.4545C9.81818 13.0332 10.0481 13.5882 10.4572 13.9973C10.8664 14.4065 11.4213 14.6364 12 14.6364C12.5787 14.6364 13.1336 14.4065 13.5428 13.9973C13.9519 13.5882 14.1818 13.0332 14.1818 12.4545C14.1818 11.8759 13.9519 11.3209 13.5428 10.9118C13.1336 10.5026 12.5787 10.2727 12 10.2727ZM12 16.0909C11.0356 16.0909 10.1107 15.7078 9.4287 15.0258C8.74675 14.3439 8.36364 13.419 8.36364 12.4545C8.36364 11.4901 8.74675 10.5652 9.4287 9.88325C10.1107 9.2013 11.0356 8.81818 12 8.81818C12.9644 8.81818 13.8893 9.2013 14.5713 9.88325C15.2532 10.5652 15.6364 11.4901 15.6364 12.4545C15.6364 13.419 15.2532 14.3439 14.5713 15.0258C13.8893 15.7078 12.9644 16.0909 12 16.0909ZM12 7C8.36364 7 5.25818 9.26182 4 12.4545C5.25818 15.6473 8.36364 17.9091 12 17.9091C15.6364 17.9091 18.7418 15.6473 20 12.4545C18.7418 9.26182 15.6364 7 12 7Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.43168c1a.svg";
export { ForwardRef as ReactComponent };